import styled from 'styled-components'

export const CenterContainer = styled.div`
  width: 100%;
  max-width: 500px;
`
